import { transformDate } from '../../pipes/ocr-date.pipe';
import { ExtractedDataSnapshot } from '../../models/extracted-values';
import { AuditOrderDto } from '../../models/interfaces';

export function mapAuditOrderDto(snapshot: ExtractedDataSnapshot): AuditOrderDto {
  const claimNumber = snapshot.fields['kopfdaten_schadennummer'] as string;
  const businessTransaction = (snapshot.fields['kopfdaten_kennung'] as string) ?? '';
  const messageForVyda = (snapshot.fields['kopfdaten_vyda_nachricht'] as string) ?? '';
  const claimantFirstName =
    (snapshot.fields['kopfdaten_vorname_betroffene_person'] as string) ?? '';
  const claimantLastName =
    (snapshot.fields['kopfdaten_nachname_betroffene_person'] as string) ?? '';
  const claimantBirthDate = snapshot.fields['kopfdaten_geburtsdatum'] as string;
  const damageDate = (snapshot.fields['kopfdaten_schadendatum'] as string) ?? '';
  const kstName = (snapshot.fields['kostentraeger_name'] as string) ?? '';
  const kstStreet = (snapshot.fields['kostentraeger_strasse'] as string) ?? '';
  const kstNr = (snapshot.fields['kostentraeger_hausnummer'] as string) ?? '';
  const kstStreetNr = `${kstStreet} ${kstNr}`;
  const kstZip = (snapshot.fields['kostentraeger_postleitzahl'] as string) ?? '';
  const kstPlace = (snapshot.fields['kostentraeger_stadt'] as string) ?? '';
  const kstZipPlace = `${kstZip} ${kstPlace}`;
  const clerkClaimAmount = (snapshot.fields['kopfdaten_gesamtbetrag'] as number) ?? 0;
  const proofType = snapshot.fields['auftragsart'] as string;
  const tenantName = snapshot.fields['tenant'] as string;
  const clerkFirst = (snapshot.fields['sachbearbeiter_vorname'] as string) ?? '';
  const clerkLast = (snapshot.fields['sachbearbeiter_nachname'] as string) ?? '';
  const clerkMail = (snapshot.fields['sachbearbeiter_email'] as string) ?? '';
  const clerkPhone = (snapshot.fields['sachbearbeiter_telefon'] as string) ?? '';
  return {
    tenantName,
    clerk: {
      firstName: clerkFirst,
      lastName: clerkLast,
      email: clerkMail,
      phone: clerkPhone,
    },
    auditData: {
      claimNumber,
      businessTransaction,
      claimantFirstName,
      claimantLastName,
      claimantBirthDate: claimantBirthDate
        ? transformDate(claimantBirthDate).format('YYYY-MM-DD')
        : '',
      damageDate: damageDate ? transformDate(damageDate).format('YYYY-MM-DD') : '',
      kstName,
      kstStreetNr,
      kstZipPlace,
      clerkClaimAmount,
      proofType,
    },
    messageForVyda,
    auditFiles: [],
    shouldSendToCt: false,
    initialOrderDescription: '',
  };
}
